import { PaymentParams } from 'app/models/payments-params'
import { KpiProps } from 'app/views/components/KPI/KPI'
import { useKPIFilters } from 'app/views/components/KPI/KPI-filters'
import { useEffect } from 'react'

export const getKPIData = (
  data: PaymentParams[],
  setData: React.Dispatch<React.SetStateAction<PaymentParams[]>>,
): KpiProps[] => {
  const filterFunctions: Record<string, (payment: PaymentParams) => boolean> = {
    'Repayment or Prepayment': (payment: PaymentParams) =>
      ['Repayment', 'Prepayment'].includes(payment.payment.transactionType),
    'Principal Payments': (payment: PaymentParams) =>
      payment.payment.transactionType.includes('Principal'),
    'New Borrowings': (payment: PaymentParams) =>
      payment.payment.transactionType.includes('NewBorrowing'),
    'Fee Payments': (payment: PaymentParams) =>
      payment.payment.transactionType === 'FeePaymentTransaction',
    'Fronted Payments': (payment: PaymentParams) =>
      payment.payment.fronting === true,
  }

  const { applyFilter, appliedFilters } = useKPIFilters({
    data,
    filterFunctions,
    setData,
  })

  useEffect(() => {
    if (appliedFilters.size === 0) return;
    applyFilter(null);
  }, [data]);

  if (!data) return []

  const repaymentOrPrepayment = data.filter(row =>
    ['Repayment', 'Prepayment'].includes(row.payment.transactionType),
  )
  const principalPayments = data.filter(row =>
    row.payment.transactionType.includes('Principal'),
  )
  const newBorrowings = data.filter(row =>
    row.payment.transactionType.includes('NewBorrowing'),
  )
  const feePayments = data.filter(
    row => row.payment.transactionType === 'FeePaymentTransaction',
  )
  const frontedPayments = data.filter(row => row.payment.fronting)

  return [
    {
      title: 'Payments Today',
      amount: repaymentOrPrepayment.length,
      activeFilter: appliedFilters.has('Repayment or Prepayment'),
      event: () => applyFilter('Repayment or Prepayment'),
    },
    {
      title: 'Principal Payments',
      amount: principalPayments.length,
      activeFilter: appliedFilters.has('Principal Payments'),
      event: () => applyFilter('Principal Payments'),
    },
    {
      title: 'New Borrowings',
      amount: newBorrowings.length,
      activeFilter: appliedFilters.has('New Borrowings'),
      event: () => applyFilter('New Borrowings'),
    },
    {
      title: 'Fees',
      amount: feePayments.length,
      activeFilter: appliedFilters.has('Fee Payments'),
      event: () => applyFilter('Fee Payments'),
    },
    {
      title: 'Fronted Payments',
      amount: frontedPayments.length,
      activeFilter: appliedFilters.has('Fronted Payments'),
      event: () => applyFilter('Fronted Payments'),
    },
  ]
}
